module.exports = __webpack_public_path__ + "fonts/Nunito-300-cyrillic-ext1.37ea4db.woff2";